import { getCookie } from './cookie';

export const getActiveLanguage = () => {
	const defaultLanguage = 'en';
	const cookieLanguage = getCookie('language');

	return cookieLanguage || defaultLanguage;
};
